// import React, { useRef, useState } from "react";
// import GoogleMapReact from "google-map-react";

// const Marker = ({}) => <div style={{ fontSize: "20px" }}>{"📍"}</div>;

// export default function SimpleMap({ lat, lng, set,close}) {

//   const mapRef = useRef();
//   const [lldata, SetLLData] = useState({ lat, lng });
//   const createMapOptions = {
//     panControl: false,
//     mapTypeControl: false,
//     scrollwheel: false,
//     draggableCursor: "default",
//     draggingCursor: "pointer",
//   };

//   const defaultProps = {
//     center: { lat, lng },
//     zoom: 11,
//   };
//    const handleLatLong=()=>{
//     set(lldata);
//     close(false);

//    }

//   return (
//     <>
//       <div style={{ height: "400px", width: "650px" }}>
//         <GoogleMapReact
//           bootstrapURLKeys={{ key: "AIzaSyABE5oLDQJp-iEBTdd1QdTi0J8io3ufq6o" }}
//           defaultCenter={defaultProps.center}
//           defaultZoom={defaultProps.zoom}
//           yesIWantToUseGoogleMapApiInternals
//           onGoogleApiLoaded={({ map }) => {
//             mapRef.current = map;
//           }}
//           onClick={(e) => SetLLData({ lat: e.lat, lng: e.lng })}
//           options={createMapOptions}
//         >
//           <Marker lat={lldata.lat} lng={lldata.lng} text="My Marker" />
//         </GoogleMapReact>
//       </div>
//       <div>
//         <div className="row my-1 mt-3">

//           {`lat: ${lldata.lat}`}&nbsp; {`lan: ${lldata.lng}`}{" "}
//           &nbsp;  <button
//             className="btn-xs btn-warning"
//             onClick={handleLatLong}
//           >
//             Save
//           </button>&nbsp;&nbsp;
//           <button
//             className="btn-xs btn-danger"
//             onClick={()=> close(false)}
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     </>
//   );
// }

import React, { useRef, useState, useEffect } from "react";
import GoogleMapReact from "google-map-react";

export default function SimpleMap({ lat, lng, set, close }) {
  const mapRef = useRef();
  const mapsRef = useRef();
  const [lldata, SetLLData] = useState({
    lat: Number(lat) || 0,
    lng: Number(lng) || 0,
  });

  const [highlight, setHighlight] = useState(false);
  const [center, setCenter] = useState({ lat, lng }); // dynamic center

  useEffect(() => {
    // Try to detect user's current device location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLng = position.coords.longitude;
          SetLLData({ lat: userLat, lng: userLng });
          setCenter({ lat: userLat, lng: userLng });
        },
        (error) => {
          console.warn("Geolocation blocked or failed, using default coords");
          setCenter({ lat, lng });
        },
      );
    } else {
      console.warn("Geolocation not supported, using default coords");
      setCenter({ lat, lng });
    }
  }, [lat, lng]);

  const mapOptions = {
    panControl: false,
    mapTypeControl: false,
    scrollwheel: true,
    fullscreenControl: true,
    styles: [
      { featureType: "poi.business", stylers: [{ visibility: "off" }] },
      { featureType: "transit", stylers: [{ visibility: "off" }] },
    ],
  };

  const handleLatLong = () => {
    set(lldata);
    close(false);
  };

  const handleMapClick = (e) => {
    const newLat = Number(e.lat);
    const newLng = Number(e.lng);
    SetLLData({ lat: newLat, lng: newLng });
    setHighlight(true);

    if (mapRef.current && mapsRef.current) {
      mapRef.current.panTo({ lat: newLat, lng: newLng });
    }
  };

  const Marker = ({ isHighlighted }) => (
    <div style={styles.markerWrapper}>
      <div
        style={{
          ...styles.markerOuter,
          boxShadow: isHighlighted
            ? "0 0 12px 4px rgba(0,123,255,0.6)"
            : "0 0 3px rgba(0,0,0,0.3)",
          transform: isHighlighted
            ? "translate(-50%, -100%) scale(1.2)"
            : "translate(-50%, -100%) scale(1)",
        }}
      >
        <div style={styles.markerPin}></div>
        <div style={styles.markerDot}></div>
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translate(-50%, -100%) translateY(0); }
          50% { transform: translate(-50%, -100%) translateY(-6px); }
        }
      `}</style>

      <div style={styles.mapBox}>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: "AIzaSyABE5oLDQJp-iEBTdd1QdTi0J8io3ufq6o",
          }}
          center={center}
          defaultZoom={13}
          options={mapOptions}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => {
            mapRef.current = map;
            mapsRef.current = maps;
          }}
          onClick={handleMapClick}
        >
          <Marker lat={lldata.lat} lng={lldata.lng} isHighlighted={highlight} />
        </GoogleMapReact>
      </div>

      <div style={styles.footer}>
        <div style={styles.coords}>
          <span>
            <strong>Lat:</strong> {Number(lldata?.lat || 0).toFixed(6)}
          </span>
          &nbsp;|&nbsp;
          <span>
            <strong>Lng:</strong> {Number(lldata?.lng || 0).toFixed(6)}
          </span>
        </div>

        <div style={styles.btnGroup}>
          <button
            style={{ ...styles.btn, ...styles.saveBtn }}
            onClick={handleLatLong}
          >
            Save
          </button>
          <button
            style={{ ...styles.btn, ...styles.cancelBtn }}
            onClick={() => close(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

// --- Inline Styles ---
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontFamily: "'Inter', sans-serif",
  },
  mapBox: {
    height: "420px",
    width: "680px",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "680px",
    marginTop: "10px",
    background: "#f9fafb",
    borderRadius: "10px",
    padding: "10px 16px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
  },
  coords: {
    fontSize: "14px",
    color: "#333",
  },
  btnGroup: {
    display: "flex",
    gap: "10px",
  },
  btn: {
    border: "none",
    borderRadius: "6px",
    padding: "6px 14px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  saveBtn: {
    backgroundColor: "#ffc107",
    color: "#000",
  },
  cancelBtn: {
    backgroundColor: "#dc3545",
    color: "#fff",
  },
  markerWrapper: {
    position: "relative",
    transform: "translate(-50%, -100%)",
    cursor: "pointer",
    animation: "bounce 1.5s infinite",
  },
  markerOuter: {
    position: "relative",
    width: "26px",
    height: "26px",
    backgroundColor: "#007bff",
    borderRadius: "50% 50% 50% 0",
    transform: "rotate(-45deg)",
    border: "2px solid #fff",
    transition: "all 0.3s ease",
  },
  markerDot: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "8px",
    height: "8px",
    backgroundColor: "#fff",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
  },
  markerPin: {
    position: "absolute",
    bottom: "-6px",
    left: "50%",
    width: "4px",
    height: "8px",
    backgroundColor: "#007bff",
    borderRadius: "2px",
    transform: "translateX(-50%)",
  },
};
